export const ACCRUALS_CONFIG_ASSETS = {
  EMPTY_ILLUSTRATION: '/img/accruals/configuration/empty-state-illustration@2x.png',
  ICON_PLUS_WHITE: '/img/accruals/configuration/icon-plus-white.svg',
  ICON_PLUS_DARK: '/img/accruals/configuration/icon-plus-dark.svg',
  ICON_INFO_BANNER: '/img/accruals/configuration/icon-info-banner.svg',
  ICON_EDIT: '/img/accruals/configuration/pencil-edit.svg',
  ICON_CHECK: '/img/accruals/configuration/icon-check.svg',
  ICON_DELETE: '/img/accruals/configuration/icon-delete.svg',
  ICON_X_CIRCLE: '/img/accruals/configuration/icon-x-circle.svg',
  ICON_CHEVRON_DOWN: '/img/accruals/configuration/icon-chevron-down.svg',
  ICON_DRAG_HANDLE: '/img/accruals/configuration/icon-drag-handle.svg',
  ICON_CHIP_REMOVE: '/img/accruals/configuration/icon-chip-remove.svg',
  ICON_METHOD_CHECK: '/img/accruals/configuration/icon-method-check.svg',
  ICON_FILE: '/img/accruals/icon-file-master.svg',
  ICON_INFO_REQUEST: '/img/navicon/fbc-nav/InfoRequest.svg',
};

export const RULES_BUILDER_SUBTITLE = 'Match conditions on PO data';

export const ACCRUALS_CONFIG_TABS = {
  ESTIMATION: 'estimation-rules',
  INFO_REQUEST: 'info-request-rules',
};

export const ACCRUALS_CONFIG_TAB_ITEMS = [
  {
    id: ACCRUALS_CONFIG_TABS.ESTIMATION,
    label: 'Estimation rules',
    icon: ACCRUALS_CONFIG_ASSETS.ICON_FILE,
  },
  {
    id: ACCRUALS_CONFIG_TABS.INFO_REQUEST,
    label: 'Info Request Rules',
    icon: ACCRUALS_CONFIG_ASSETS.ICON_INFO_REQUEST,
  },
];

export const CONDITION_OPERATORS = [
  { value: 'gt', label: '> Greater than' },
  { value: 'gte', label: '>= Greater than or equal' },
  { value: 'lt', label: '< Less than' },
  { value: 'lte', label: '<= Less than or equal' },
  { value: 'eq', label: '= Equals' },
  { value: 'neq', label: '!= Not equals' },
  { value: 'contains', label: 'Contains' },
  { value: 'not_contains', label: 'Does not contain' },
  { value: 'date_after', label: 'Date after' },
  { value: 'date_before', label: 'Date before' },
  { value: 'is_empty', label: 'Is empty' },
  { value: 'is_not_empty', label: 'Is not empty' },
];

/** Canonical open_po fields only — must match supernova OPEN_PO_FIELDS / silkroute schemas. */
export const OPEN_PO_CONDITION_FIELDS = [
  { value: 'po_number', label: 'po_number', type: 'text' },
  { value: 'po_line_number', label: 'po_line_number', type: 'text' },
  { value: 'subsidiary_code', label: 'subsidiary_code', type: 'text' },
  { value: 'supplier_id', label: 'supplier_id', type: 'text' },
  { value: 'supplier_name', label: 'supplier_name', type: 'text' },
  { value: 'po_currency', label: 'po_currency', type: 'text' },
  { value: 'total_po_value', label: 'total_po_value', type: 'number' },
  { value: 'open_po_value', label: 'open_po_value', type: 'number' },
  { value: 'po_creation_date', label: 'po_creation_date', type: 'date' },
  { value: 'po_status', label: 'po_status', type: 'text' },
  { value: 'gl_account', label: 'gl_account', type: 'text' },
  { value: 'cost_center', label: 'cost_center', type: 'text' },
];

/** @deprecated Prefer OPEN_PO_CONDITION_FIELDS — estimation still uses a subset until 6677. */
export const ESTIMATION_CONDITION_FIELDS = [
  { value: 'open_po_value', label: 'open_po_value', type: 'number' },
  { value: 'subsidiary_code', label: 'subsidiary_code', type: 'text' },
  { value: 'supplier_id', label: 'supplier_id', type: 'text' },
  { value: 'po_status', label: 'po_status', type: 'text' },
];

export const INFO_REQUEST_CONDITION_FIELDS = OPEN_PO_CONDITION_FIELDS;

export const EMPTY_STATE_COPY = {
  [ACCRUALS_CONFIG_TABS.ESTIMATION]: {
    title: 'No rules yet',
    description: 'Add your first rule to define how Noa should estimate each PO type.',
  },
  [ACCRUALS_CONFIG_TABS.INFO_REQUEST]: {
    title: 'No rules yet',
    description: 'Add your first rule to define when Noa should send an info request.',
  },
};

export const INFO_BANNER_COPY = {
  [ACCRUALS_CONFIG_TABS.ESTIMATION]:
    'All conditions must be met (AND logic) for a PO to qualify for estimation',
  [ACCRUALS_CONFIG_TABS.INFO_REQUEST]:
    'Match groups with AND/OR. Within each group, Match ALL or Match ANY of the conditions.',
};

export const IM_GROUP_LOGIC = {
  AND: 'AND',
  OR: 'OR',
};

export function createEmptyCondition(index = 0) {
  return {
    id: `condition-${Date.now()}-${index}`,
    field: '',
    operator: 'eq',
    value: '',
  };
}

export function createEmptyImGroup(index = 0) {
  return {
    id: `group-${Date.now()}-${index}`,
    logic: IM_GROUP_LOGIC.AND,
    conditions: [createEmptyCondition(0)],
  };
}

export function createInitialImGroups() {
  return [createEmptyImGroup(0)];
}

/** Canonical ap_postings fields — must match supernova AP_POSTINGS_FIELDS. */
export const ESTIMATION_AP_CONDITION_FIELDS = [
  { value: 'transaction_id', label: 'transaction_id', type: 'text' },
  { value: 'transaction_type', label: 'transaction_type', type: 'text' },
  { value: 'po_number', label: 'po_number', type: 'text' },
  { value: 'supplier_id', label: 'supplier_id', type: 'text' },
  { value: 'invoice_amount', label: 'invoice_amount', type: 'number' },
  { value: 'ap_balance_impact', label: 'ap_balance_impact', type: 'number' },
  { value: 'transaction_date', label: 'transaction_date', type: 'date' },
  { value: 'invoice_status', label: 'invoice_status', type: 'text' },
  { value: 'subsidiary_code', label: 'subsidiary_code', type: 'text' },
  { value: 'tax_amount', label: 'tax_amount', type: 'number' },
  { value: 'transaction_currency', label: 'transaction_currency', type: 'text' },
  { value: 'functional_currency', label: 'functional_currency', type: 'text' },
  { value: 'posting_period', label: 'posting_period', type: 'text' },
  { value: 'due_date', label: 'due_date', type: 'date' },
];

export const ESTIMATION_SOURCE_OPTIONS = [
  { value: 'open_po', label: 'PO' },
  { value: 'ap_postings', label: 'Vendor' },
];

export const TEMPLATE_CARDS = {
  'AP-01': {
    code: 'AP-01',
    source: 'ap_postings',
    label: 'Last Comparable Invoice',
    description: 'Uses the most recent AP invoice from the same period last year.',
  },
  'AP-02': {
    code: 'AP-02',
    source: 'ap_postings',
    label: 'Historical Average',
    description: 'Average AP posting amounts over a lookback window (e.g. last 6 months).',
  },
  'AP-03': {
    code: 'AP-03',
    source: 'ap_postings',
    label: 'Post-Cutoff Invoice',
    description: 'Uses an invoice received shortly after the cutoff date.',
  },
  'PO-01': {
    code: 'PO-01',
    source: 'open_po',
    label: 'Full Open Balance',
    description: 'Accrues the complete remaining PO balance.',
  },
  'PO-02': {
    code: 'PO-02',
    source: 'open_po',
    label: 'Percentage of Open Balance',
    description: 'Accrues a configured share of the remaining PO balance.',
  },
  'PO-03': {
    code: 'PO-03',
    source: 'open_po',
    label: 'Receipt-Based Accrual',
    description: 'Accrues based on goods received not invoiced.',
  },
};

export const TEMPLATE_CARDS_BY_SOURCE = {
  ap_postings: [TEMPLATE_CARDS['AP-01'], TEMPLATE_CARDS['AP-02'], TEMPLATE_CARDS['AP-03']],
  open_po: [TEMPLATE_CARDS['PO-01'], TEMPLATE_CARDS['PO-02'], TEMPLATE_CARDS['PO-03']],
};

export function getConditionFieldsForSource(source) {
  return source === 'ap_postings' ? ESTIMATION_AP_CONDITION_FIELDS : OPEN_PO_CONDITION_FIELDS;
}

export function createEmptyComputationRule(overrides = {}) {
  const source = overrides.source || 'open_po';
  const templateCode = overrides.template_code
    || (source === 'ap_postings' ? 'AP-01' : 'PO-01');
  return {
    name: 'New rule',
    status: 'saved',
    source,
    template_code: templateCode,
    template_settings: {},
    effective_from: null,
    effective_to: null,
    vendor_scope: { mode: 'all_vendors', supplier_ids: [] },
    conditions: [
      { ...createEmptyCondition(0), field: 'supplier_id', operator: 'eq', value: '' },
      {
        ...createEmptyCondition(1),
        field: source === 'ap_postings' ? 'invoice_amount' : 'open_po_value',
        operator: 'gt',
        value: '',
      },
    ],
    connectors: ['and'],
    default_gl: { enabled: false, debit_gl: null, credit_gl: null },
    ...overrides,
  };
}

export function getConditionFieldsForTab(tabId) {
  return tabId === ACCRUALS_CONFIG_TABS.INFO_REQUEST
    ? INFO_REQUEST_CONDITION_FIELDS
    : ESTIMATION_CONDITION_FIELDS;
}

const OPS_BY_TYPE = {
  text: ['eq', 'neq', 'contains', 'not_contains', 'is_empty', 'is_not_empty'],
  number: ['gt', 'gte', 'lt', 'lte', 'eq', 'neq', 'is_empty', 'is_not_empty'],
  date: ['gt', 'gte', 'lt', 'lte', 'eq', 'date_after', 'date_before', 'is_empty', 'is_not_empty'],
};

export function getOperatorsForField(fieldValue) {
  const field = OPEN_PO_CONDITION_FIELDS.find((f) => f.value === fieldValue)
    || ESTIMATION_AP_CONDITION_FIELDS.find((f) => f.value === fieldValue);
  const type = field?.type || 'text';
  const allowed = new Set(OPS_BY_TYPE[type] || OPS_BY_TYPE.text);
  return CONDITION_OPERATORS.filter((op) => allowed.has(op.value));
}
